/*
 * Rental checkout guard.
 *
 * This store takes rental requests, not payments, so no customer should ever
 * reach Shopify's checkout. The theme's own checkout buttons have been
 * replaced, but this is a defence in depth for anything that renders a
 * checkout trigger outside the theme's control - PageFly blocks, third party
 * apps, cached markup, or a cart drawer that gets re-enabled later.
 *
 * Listeners run in the capture phase so they fire before the theme's own
 * handlers and before a native form submission begins.
 */

(function () {
  'use strict';

  var CHECKOUT_PATH = /(^|\/)checkout(\/|$|\?)/;

  function destination() {
    return (window.rentalRoutes && window.rentalRoutes.eventDetailsUrl) || '/pages/event-details';
  }

  function redirect() {
    window.location.href = destination();
  }

  function pointsAtCheckout(url) {
    if (!url) return false;
    try {
      var parsed = new URL(url, window.location.origin);
      if (parsed.origin !== window.location.origin) return false;
      return CHECKOUT_PATH.test(parsed.pathname);
    } catch (error) {
      return CHECKOUT_PATH.test(String(url));
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.defaultPrevented) return;

      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var trigger = target.closest(
        '[name="checkout"], a[href], .shopify-payment-button__button, .shopify-payment-button__more-options'
      );
      if (!trigger) return;

      var isCheckout =
        trigger.getAttribute('name') === 'checkout' ||
        trigger.classList.contains('shopify-payment-button__button') ||
        trigger.classList.contains('shopify-payment-button__more-options') ||
        pointsAtCheckout(trigger.getAttribute('href'));

      if (!isCheckout) return;

      event.preventDefault();
      event.stopPropagation();
      redirect();
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;

      var submitter = event.submitter;
      var submitsToCheckout =
        (submitter && submitter.getAttribute('name') === 'checkout') ||
        pointsAtCheckout(form.getAttribute('action'));

      if (!submitsToCheckout) return;

      event.preventDefault();
      event.stopPropagation();
      redirect();
    },
    true
  );
})();
